<template>
  <v-toolbar-items>
    <v-menu offset-y left>
      <v-card-title class="username-text" slot="activator">
        <template v-if="$vuetify.breakpoint.smAndUp">
          <img v-if="$store.getters.isClubRole" :src="$store.state.icon" height="30" class="logo">
          <img v-if="$store.getters.isSafRole" src="@/assets/icons/lpf_icon.png" height="30" class="logo">
          <div class="white--text">{{ this.$store.state.authUser }}</div>
        </template>
      </v-card-title>

      <v-list class="menu-content">
        <v-list-tile @click="goChangePassword">
          <v-list-tile-title>Cambiar contraseña</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-btn flat icon @click="logout" class="padding: 0 0 0 0; margin: 0 0 0 0;">
      <v-tooltip bottom open-delay="50" close-delay="50">
        <v-icon slot="activator" color="white">exit_to_app</v-icon>
        <span>Salir</span>
      </v-tooltip>
    </v-btn>
  </v-toolbar-items>
</template>

<script>
export default {
  methods: {
    logout () {
      this.$store.commit('logout')
      this.$router.push({ name: 'dashboard' })
    },
    goChangePassword () {
      this.$router.push({ name: 'changePassword' })
    }
  }
}
</script>

<style scoped>
.logo {
  margin-right: 0.75em;
}
.username-text {
  padding-right: 0.5em;
  padding-left: 0.5em;
}

.username-text:hover{
  background: hsla(180, 0%, 15%, 0.25);
}
.menu-content:hover {
  background-color: whitesmoke;
}
</style>
